(function ($) {

RVwys.plugin['common'] = true;


	$(document).bind('editorReady',function(){
		
		  $('.rv-thumb-active div').click(function(e) {

			  $(this).parent().find('.uk-active').removeClass('uk-active');   
			  $(this).addClass('uk-active');  
				
	        });
		
	});
	
	$(document).bind('designReady',function(e){
		
	});



	


	
	
})(jQuery);